"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMarginPercentageToColour = void 0;
const getMarginPercentageToColour = (val) => {
    if (val <= 0) {
        return "rgba(207,63,55,0.5)";
    }
    if (val >= 0 && val <= 0.1) {
        return "#EBEDF0";
    }
    if (val > 0.1 && val <= 5) {
        return "rgba(58, 175, 62, 0.1)";
    }
    if (val > 5 && val <= 7.5) {
        return "rgba(58, 175, 62, 0.2)";
    }
    if (val > 7.5 && val <= 10) {
        return "rgba(58, 175, 62, 0.3)";
    }
    if (val > 10 && val <= 12.5) {
        return "rgba(58, 175, 62, 0.4)";
    }
    if (val > 12.5 && val <= 15) {
        return "rgba(58, 175, 62, 0.55)";
    }
    if (val > 15 && val <= 17.5) {
        return "rgba(58, 175, 62, 0.7)";
    }
    if (val > 17.5 && val <= 20) {
        return "rgba(58, 175, 62, 0.85)";
    }
    if (val > 20) {
        return "rgba(58, 175, 62, 1)";
    }
};
exports.getMarginPercentageToColour = getMarginPercentageToColour;
